module.exports = __webpack_public_path__ + "img/tinder.366d5b7.png";